import { render, staticRenderFns } from "./UserBulkActions.vue?vue&type=template&id=4d19987a&"
import script from "./UserBulkActions.vue?vue&type=script&lang=js&"
export * from "./UserBulkActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports